import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AsignacionesMrIconComponent } from '../asignaciones-mr-icon/asignaciones-mr-icon.component';
import {
  AsignacionesService,
  Ticket,
  TICKET_PRIORITY_ICONS,
  TICKET_PRIORITY_LABELS,
  TICKET_STATUS_LABELS,
} from 'src/app/services/asignaciones.service';
import { TicketTypeCatalogService } from '../../services/ticket-type-catalog.service';
import { getAsignacionesActorEmployeeId } from '../../utils/asignaciones-actor.util';

@Component({
  selector: 'app-asignaciones-my-assignments',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, AsignacionesMrIconComponent],
  templateUrl: './asignaciones-my-assignments.component.html',
  styleUrls: ['./asignaciones-my-assignments.component.scss'],
})
export class AsignacionesMyAssignmentsComponent implements OnInit, OnDestroy {
  open = signal(false);
  loading = signal(false);
  tickets = signal<Ticket[]>([]);

  readonly statusLabels = TICKET_STATUS_LABELS;
  readonly priorityLabels = TICKET_PRIORITY_LABELS;
  readonly priorityIcons = TICKET_PRIORITY_ICONS;

  constructor(
    private service: AsignacionesService,
    private typeCatalog: TicketTypeCatalogService,
    private router: Router,
  ) {}

  typeDisplay(ticket: Ticket) {
    return this.typeCatalog.lookup(ticket.type, ticket.workareaId);
  }

  ngOnInit(): void {
    this.typeCatalog.ensureLoaded().subscribe();
    this.loadAssignments();
    this.refreshTimer = setInterval(() => this.loadAssignments(), 60_000);
  }

  private employeeId: number | undefined = getAsignacionesActorEmployeeId();
  private refreshTimer: ReturnType<typeof setInterval> | null = null;

  ngOnDestroy(): void {
    if (this.refreshTimer) clearInterval(this.refreshTimer);
  }

  get pendingCount(): number {
    return this.tickets().length;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement | null;
    if (!target?.closest('.asignaciones-my-assignments')) {
      this.open.set(false);
    }
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    const next = !this.open();
    this.open.set(next);
    if (next) this.loadAssignments();
  }

  openTicket(ticket: Ticket, event: MouseEvent): void {
    event.stopPropagation();
    this.open.set(false);
    this.router.navigate(['/asignaciones/ticket', ticket.id]);
  }

  viewAll(event: MouseEvent): void {
    event.stopPropagation();
    this.open.set(false);
    this.router.navigate(['/asignaciones']);
  }

  private loadAssignments(): void {
    this.employeeId = getAsignacionesActorEmployeeId();
    if (!this.employeeId) return;

    this.loading.set(true);
    this.service.getTickets({ assigneeId: this.employeeId, limit: 100 }).subscribe({
      next: (res) => {
        const items = (res?.data?.tickets || []).filter((t) => t.status !== 'terminado');
        this.tickets.set(items);
        this.loading.set(false);
      },
      error: () => this.loading.set(false),
    });
  }
}
